import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {EditableFault, FaultState} from '../shared/editable-fault/editable-fault';
import {Status} from '../../core/status/status';
import {Activity} from '../../core/activity/activity';
import {WeblinkUserService} from '../shared/weblink-user.service';
import {WeblinkSettings} from "@docma-weblink/shared/weblink-data/weblink-data";
import {WeblinkFaultService} from "@docma-weblink/shared/weblink-fault.service";


@Component({
  selector: 'app-weblink-fault-edit',
  templateUrl: './weblink-fault-edit.component.html',
  styleUrls: ['./weblink-fault-edit.component.css']
})
export class WeblinkFaultEditComponent implements OnInit {

  files: FileList;
  fault: EditableFault;

  @Input('faults') faults: EditableFault[];
  @Input() settings: WeblinkSettings;
  @Input('status') status: Status[];

  @Output() closeDialog = new EventEmitter();
  @Output() cancelDialog = new EventEmitter();

  currentUser: string="";
  multipleAttachmentsEnabled: boolean = false;

  constructor(private userService: WeblinkUserService,
              private weblinkFaultService: WeblinkFaultService) {

    this.currentUser= userService.getCurrentUser();
   }

  async ngOnInit() {
    const version = await this.weblinkFaultService.version().toPromise();
    this.multipleAttachmentsEnabled = (version.Service.Major >= 3 && version.Service.Minor >= 0);

    this.fault = new EditableFault();
    if (this.status.length === 1) {
      this.fault.newStatus = this.status[0];
    }
  }

  save() {
    this.faults.forEach((fault) => {
      const activity = new Activity();
      const desc = this.fault.newText ? this.fault.newText + ` [${this.currentUser}]` : `[${this.currentUser}]`  ;
      activity.Status = this.fault.newStatus;
      activity.Description = desc;
      fault.Activities = [ activity ];
      fault.newStatus = this.fault.newStatus;
      fault.newText = desc;
      fault.newFiles = this.fault.newFiles;
      fault.faultState = FaultState.mustUpload;
    });
    this.closeDialog.emit();
  }

  cancel() {
    this.cancelDialog.emit();
  }

  removeAttachment(index) {
    const dt = new DataTransfer()

    for (let i = 0; i < this.files.length; i++) {
      const file = this.files[i]
      if (index !== i)
        dt.items.add(file) // here you exclude the file. thus removing it.
    }

    this.files = dt.files;
    // this.file.nativeElement.files = this.files;
    this.fault.newFiles = Array.from(this.files);
  }

  addFiles(event) {
    const dt = new DataTransfer()
    const filesInternal: File[] = [];

    (this.files ? Array.from(this.files) : [])
      .concat(Array.from(event.target.files)).forEach(f => {
      const found = filesInternal.findIndex(x => x.name == f.name && x.webkitRelativePath == f.webkitRelativePath && x.lastModified == f.lastModified);
      if (found === -1 && dt.items.length < 5) {
        filesInternal.push(f);
        dt.items.add(f);
      }
    });

    this.files = dt.files;

    if (this.files.length >= 1) {
      this.fault.newFiles = Array.from(this.files);
      this.fault.newFormData = new FormData();
      this.fault.newFiles.forEach(f => {
        this.fault.newFormData.append(f.name, f, f.name);     //'file'  `file_${i}`
      });

    } else {
      this.fault.newFiles = [];
      this.fault.newFormData = null;
    }
  }

}
